module.exports = __webpack_public_path__ + "static/media/organize_event_responsive.6335f70f.png";